/**
 * @file 路由守卫配置
 */
import router from '@/router'
import store from '@/store'
import loadingBar from 'library/components/loadingBar'
import { userInfo } from '@/common/request'
import { hasAuth } from '@/common/utils/auth'
import { clearState } from '@/common/utils/clearState'

/**
 * 配置路由守卫
 */
export function setupRouter() {
    router.beforeEach((to, from, next) => {
        let user = store.state.userInfo
        let path = from.path
        // 是否登录
        if (!user.id) {
            /**
             * 获取用户的基本信息
             */
            userInfo()
                .then((res) => {
                    store.commit('SET_USER_INFO', res.data)
                    if (to.path === '/') {
                        router.push('/')
                    }
                    next()
                })
            return
        }

        if (path) {
            // 两个/之间的就是模块名称
            let moduleNames = /([^\/]+)/.exec(path)
            if (moduleNames && moduleNames[1]) {
                clearState(moduleNames[1])
            }
        }
        let toPath = to.path
        if (toPath == '/') {
            // store.commit('SET_CRUMB_OPTIONS', [])
        } else {
            // 两个/之间的就是模块名称
            let moduleNames = /([^\/]+)/.exec(toPath)
            if (moduleNames && moduleNames[1]) {
                clearState(moduleNames[1])
            }
        }
        // 是否有权限
        if (to && to.meta && to.meta.requireAuth && hasAuth(to.meta.authName, to.meta.auth)) {
            if (!user.permissions || JSON.stringify(user.permissions) === '{}') {
                router.push('/403')
                return
            }
            loadingBar.start()
            next()
        } else if (to && to.meta && to.meta.requireAuth && !hasAuth(to.meta.authName, to.meta.auth)) {
            if (!user.permissions || JSON.stringify(user.permissions) === '{}') {
                router.push('/403')
                return
            }
            router.push('/')
            next()
        } else {
            loadingBar.start()
            next()
        }
    })

    router.afterEach(route => {
        if (route && route.meta && route.meta.requireAuth && hasAuth(route.meta.authName, route.meta.auth)) {
        } else if (route && route.meta && route.meta.requireAuth && !hasAuth(route.meta.authName, route.meta.auth)) {
            if (route.name === 'myPedding' || route.name === 'myPedding') {
                router.push('/403')
            } else {
                router.push('/')
            }
        } else {
            // console.log("afterEach不需要权限")
        }
        loadingBar.finish()
    })
}

